<script setup>
import {onMounted, ref} from 'vue';
import Section from '@/components/Section.vue';
import TextBlock from '@/components/TextBlock.vue';

const p = ref({
    bird1: {
        top: -120,
        left: 100,
        startLeft: 100,
        leftMax: 1200,
        tempo: 1,
        repeat: false,
    },
    bird2: {
        top: -115,
        left: -400,
        startLeft: -400,
        leftMax: 1200,
        tempo: 0.6,
        repeat: true
    },
    shadowBirds: {
        top: -80,
        left: -100,
        startLeft: -100,
        leftMax: 1200,
        tempo: 0.4,
        repeat: true
    },
    shadowClouds: {
        top: -100,
        left: 0,
    },
    clouds: {
        top: -100,
        left: 0,
    },
    text: {
        top: -100,
        left: 0,
    }
});

const tick = () => {
    const keys = Object.keys(p.value);
    for (const key of keys) {
        const item = p.value[key];
        if (item.tempo) {
            item.left += item.tempo;
            if (item.left > item.leftMax) {
                if (item.repeat) {
                    item.left = item.startLeft;
                }
            }
        }

    }
};

const animate = () => {
    addEventListener('scroll', () => {
        const t = document.documentElement.scrollTop;
        const top = -100 - t * 0.8;
        p.value.clouds.top = top;
        p.value.shadowClouds.top = 0.9 * top;
    });
    setInterval(() => {
        tick();
    }, 20);
};

onMounted(animate);
</script>

<template>
    <Section id="introduction">

        <div class="main">
            <img src="introduction/ground.png" alt="">
            <div class="layer" :style="{left: p.shadowClouds.left + 'px', top: p.shadowClouds.top + 'px'}">
                <img src="introduction/shadow.png" alt="">
            </div>
            <div class="layer" :style="{left: p.shadowBirds.left + 'px', top: p.shadowBirds.top + 'px'}">
                <img src="introduction/shadow-birds.png" alt="">
            </div>
            <div class="layer" :style="{left: p.bird2.left + 'px', top: p.bird2.top + 'px'}">
                <img src="introduction/bird2.png" alt="">
            </div>
            <div class="layer" :style="{left: p.clouds.left + 'px', top: p.clouds.top + 'px'}">
                <img src="introduction/clouds.png" alt="">
            </div>
            <div class="layer" :style="{left: p.bird1.left + 'px', top: p.bird1.top + 'px'}">
                <img src="introduction/bird1.png" alt="">
            </div>
            <div class="layer" :style="{left: p.text.left + 'px', top: p.text.top + 'px'}">
                <h1>
                    Cleaner air for all
                </h1>
                <TextBlock>
                    <div style="max-width: 700px;">
                        <p>
                            Every year, more than 400 000 people in the EU die prematurely due to the consequences of air pollution: this is more than 10 times the toll of road traffic accidents. Another 6.5 million people fall sick as air pollution causes diseases such as strokes, asthma and bronchitis. Air pollution also harms our natural environment, impacting both vegetation and wildlife: almost two-thirds of Europe’s ecosystems are threatened by the effects of air pollution.
                        </p>

                        <p>
                            It is time to act to prevent further damage. Find out below how the European Commission proposes to address air pollution in Europe.
                        </p>
                    </div>
                </TextBlock>
            </div>
        </div>
    </Section>
</template>


<style lang="scss" scoped>

.section-intro {
    background: #fff;
    padding: 20px 0;
}

.main {
    position: relative;
    margin-top: 160px;

    .layer {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        overflow: hidden;
    }
}
</style>
